module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-fenix.683a109e.jpg";